import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  HeaderContainer as HeaderContainerComponent,
  MapListSwitcher
} from '@spotahome/ui-library';

import './Header.scss';

const Header = ({ deviceType, onSwitcherClick }) => {
  return (
    <header
      className={classNames('header', {
        'header--redesign': deviceType === 'desktop'
      })}
    >
      <HeaderContainerComponent
        showLogin
        links={{ changeCity: true }}
        renderExtraContent={() => (
          <MapListSwitcher
            onClickLeft={() => {
              onSwitcherClick();
            }}
            onClickRight={() => {
              onSwitcherClick();
            }}
          />
        )}
      />
    </header>
  );
};

Header.propTypes = {
  onSwitcherClick: PropTypes.func.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default Header;
